import { render, staticRenderFns } from "./RecordFacets.vue?vue&type=template&id=e0c78006&"
import script from "./RecordFacets.vue?vue&type=script&lang=js&"
export * from "./RecordFacets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports